import { useQuery } from 'react-query';
import { getLocationFromZip } from '../services/geoSwissSerivces';

const useSwissGeoDataFromZip = (zip, enabled = true) =>
  useQuery(['swiss', 'geo', 'data'], () => getLocationFromZip(zip), {
    enabled: !!zip && enabled,
  });

export default useSwissGeoDataFromZip;
